import { ReactNode } from "react";
import { buildUnderwritingUiPolicyCompareUrl } from "./underwritingUi.constants";

type UnderwritingUiCompareLinkProps = {
  basePolicy: string;
  targetPolicy: string;
  children?: ReactNode;
  className?: string;
};

export default function UnderwritingUiCompareLink({
  basePolicy,
  targetPolicy,
  children = "↗",
  className = "btn btn-sm btn-outline-primary",
}: UnderwritingUiCompareLinkProps) {
  return (
    <a
      href={buildUnderwritingUiPolicyCompareUrl(basePolicy, targetPolicy)}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      {children}
    </a>
  );
}
